import { render, staticRenderFns } from "./BasePolicyRenewal.vue?vue&type=template&id=14bb9c29&scoped=true"
import script from "./BasePolicyRenewal.vue?vue&type=script&lang=js"
export * from "./BasePolicyRenewal.vue?vue&type=script&lang=js"
import style0 from "./BasePolicyRenewal.vue?vue&type=style&index=0&id=14bb9c29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bb9c29",
  null
  
)

export default component.exports